exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cr-bottom-button[data-v-28ef8ada]{position:fixed;left:-20px;right:0;bottom:0;width:calc(100% + 220px)}\n", ""]);

// exports
